import React from 'react'
import { graphql } from 'gatsby'

import type { Paragraph, ParagraphComponent } from '../types'
import type { FieldLink } from '../../../drupal'

import Container from '../../Container'
import Button from '../../ui/Button'
import { classNames } from '../../ui/utils'

export interface ButtonParagraph extends Paragraph {
	button: FieldLink
}

const ButtonParagraph: ParagraphComponent<ButtonParagraph> = ({ className, paragraph }) => (
	<Container className={classNames(className, 'text-align-center')}>
		<Button link={paragraph.button} />
	</Container>
)

export default ButtonParagraph

export const query = graphql`
	fragment ButtonParagraph on paragraph__button {
		drupal_internal__id
		button: field_link {
			title
			link
			uri
		}
	}
`
